export default __webpack_public_path__ + "static/media/rnr-sports-table-10-cn.5d686d81.webp";